export const CHIP_SIZE = {
  small: 'small',
  medium: 'medium',
} as const
